export default __webpack_public_path__ + "static/media/patio-com1.8829a625.jpg";